export default __webpack_public_path__ + "static/media/dynamic.f677b061.jpg";